import styled from 'styled-components';

export const LabelStyled = styled.label<{ hasOptionalText: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: ${({ hasOptionalText }) =>
    hasOptionalText ? 'space-between' : 'flex-start'};
  color: #666666;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;

  .optional {
    font-style: italic;
  }
`;
